export enum Domicile {
    CH = 'CH',
    GLOBAL = ' ',
}
